export default __webpack_public_path__ + "static/media/ic_equity_40.c9fbb3d7.svg";